import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AuthService } from '@core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: [
    `
      :host {
        display: flex;
        flex: 1 1 auto;
        width: 100%;
        height: 100%;
      }
    `,
  ],
})
export class AppComponent {
  constructor(private _authService: AuthService) {
    this._authService.initialize();
  }
}
